import { render, staticRenderFns } from "./RatingSuperAdminPreSelect.vue?vue&type=template&id=574e74a7"
import script from "./RatingSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./RatingSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports